<template>
	<div class="slide" :class="{ active: isActive }" :style="{ width: width }">
		<slot></slot>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isActive: false,
			slideWidth: 0,
		};
	},

	computed: {
		width() {
			return this.slideWidth + 'px';
		},
	},

	watch: {
		slideWidth: function(newValue) {
			this.slideWidth = newValue;
		},
	},
};
</script>

<style lang="stylus" scoped></style>
